import { render, staticRenderFns } from "./DonutChart81.vue?vue&type=template&id=0dd3ee89&scoped=true"
import script from "./DonutChart81.vue?vue&type=script&lang=js"
export * from "./DonutChart81.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd3ee89",
  null
  
)

export default component.exports